module.exports = __webpack_public_path__ + "img/siwelele-logo-icon.cf07b1d7.png";